const TOKEN_KEY = 'foodtracker.token'

/** A Capacitor build sets window.FT_API_BASE to the remote origin; the web build leaves it empty. */
export const apiBase = (globalThis as { FT_API_BASE?: string }).FT_API_BASE ?? ''

let token: string | null = localStorage.getItem(TOKEN_KEY)

export const getToken = () => token

export const setToken = (value: string | null) => {
  token = value
  if (value) localStorage.setItem(TOKEN_KEY, value)
  else localStorage.removeItem(TOKEN_KEY)
}

export class ApiError extends Error {
  status: number
  constructor(status: number, message: string) {
    super(message)
    this.status = status
  }
}

type Options = { method?: string; body?: unknown }

export const api = async <T>(path: string, options: Options = {}): Promise<T> => {
  const headers: Record<string, string> = {}
  if (options.body !== undefined) headers['content-type'] = 'application/json'
  if (token) headers.authorization = `Bearer ${token}`

  const response = await fetch(`${apiBase}${path}`, {
    method: options.method ?? 'GET',
    headers,
    credentials: 'include',
    body: options.body === undefined ? undefined : JSON.stringify(options.body),
  })

  if (response.status === 204) return undefined as T

  const payload = await response.json().catch(() => null)
  if (!response.ok) {
    if (response.status === 401) setToken(null)
    const message = (payload as { error?: string } | null)?.error
    throw new ApiError(response.status, message ?? `Request failed (${response.status})`)
  }
  return payload as T
}

export const query = (params: Record<string, string | number | undefined>) => {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') search.set(key, String(value))
  }
  const encoded = search.toString()
  return encoded ? `?${encoded}` : ''
}
